import Cookies from 'universal-cookie'

export default defineNuxtPlugin((_) => {
  const headersCookie = useRequestHeaders(['cookie'])
  const cookieStore = useCookieStore()
  const MAX_AGE = 3600 * 24 * 30

  const cookies = new Cookies(headersCookie?.cookie || null, {
    path: '/',
    maxAge: MAX_AGE,
  })

  for (const [key, value] of Object.entries(cookies)) {
    // @ts-expect-error type 'string' is not assignable to type CookieName
    cookieStore.setCookie(key, value)
  }

  return {
    provide: {
      // legacy http-cookies
      httpCookies: cookies,
      // strongly-typed cookie store
      cookieStore,
    },
  }
})
